export { ReviewsRatings, type ReviewsRatingsProps } from "./ReviewsRatings";
